{
  "policy-info-and-rates": "Policy Info & Rates",
  "owners-policy": "Owner's Policy",
  "lenders-policy": "Lender's Policy",
  "remove-section-13": "Remove Section 13",
  "endorsements": "Endorsements",
  "owner": "Owner",
  "lender": "Lender",
  "no-endorsement": "No Endorsements Available",
  "endorsement": "Endorsement",
  "charge": "Charge",
  "description": "Description",
  "price": "Price",
  "tooltip": "Taxes cannot be edited for this closing state",
  "actual": "Actual",
  "disclosed": "Disclosed",
  "paid-by": "Paid By",
  "buyer": "Buyer",
  "seller": "Seller",
  "split": "Split",
  "disclosed-title-payee": "Disclosed Title Payee",
  "payment-breakdown": "Payment Breakdown",
  "policy": "Policy",
  "fees-taxes": "Fees / Taxes",
  "remove": "Remove",
  "total": "Total",
  "alert-p-1": "To view policy values, please ensure purchase price and loan amounts are entered in the properties screen",
  "payee-info": "Payee Information",
  "not-defined-yet": "Not Defined Yet",
  "credits": "Credits",
  "removeEndorsement": "Remove Endorsement",
  "removeConfirmation": "Are you sure you want to remove the endorsement?",
  "removeButton": "Remove",
  "endorsementRemoved": "The endorsement was removed",
  "endorsementAdded": "Endorsement Added",
  "endorsementExisting": "Existing endorsement",
  "policyTypeLabel": "Policy Type",
  "rateTypeLabel": "Rate Type",
  "rateTypeStatCodeLabel": "Rate Type Stat Code",
  "disclosureSectionLabel": "Disclosure Section",
  "association-deleted": "Association Deleted",
  "deleting": "Deleting",
  "totalCoverage": "Total coverage"
}
